import { PaymentProcessorConfigurationBase } from '../payment-processor-configuration-base';

export class CityHallSystemPaymentProcessorConfiguration extends PaymentProcessorConfigurationBase {
  constructor(options?: Partial<CityHallSystemPaymentProcessorConfiguration>) {
    super(options);
    if (options) {
      Object.assign(this, options);
    }
  }
}
